export const ALLOWED_HISTORY_PROVIDERS = ['EXPERIAN'];
